import React, {Component} from 'react';

import _ from 'lodash';
import axios from "axios/index";
import {Link} from 'react-router-dom';
import swal from 'sweetalert2';

import urls from "../../../../utils/urls";
import Header from '../../../Header/index';
import ProgrammingForm from '../newTrip/ProgrammingForm';
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import translator from "../../../../utils/translations";
import { Spinner } from '../../../../components/Loading/Spinner';


export default class TripProgrammingForm extends Component {

    constructor(props) {
        super(props);

        let {trip} = props;

        this.state = {
            id: trip.id,
            ajaxInProgress: false,
            products: false,
            operation_types: false,
            terminals: false,
            destination_areas: false,
            terminal: trip.terminal.id,
            carrier: trip.carrier,
            truck_plate: trip.truck_plate,
            trailer_plate: trip.trailer_plate,
            driver_name: trip.driver_name,
            driver_doc: trip.driver_doc,
            operation_type: trip.operation_type.id,
            estimated_load_date: trip.estimated_load_date,
            product: trip.product.id,
            destination_area: trip.destination_area.id,
            contact: trip.contact,
            shell_trip_receipt: trip.shell_trip_receipt,
            provider_trip_receipt: trip.provider_trip_receipt,
            business_observations: trip.business_observations,
        }
    }

    componentDidMount() {
        this._fetchFiltersOptions();
    }

    _fetchFiltersOptions = () => {
        const operation_type = `${urls.API_ROOT}/api/v1/operation_type/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const areas = `${urls.API_ROOT}/api/v1/destinationarea/`;
        axios.all([
            axios.get(operation_type, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
            axios.get(areas, tokenHeader()),
        ])
            .then(axios.spread(function (oper, term, prod, area) {
                return {
                    operation_types: oper,
                    products: prod,
                    terminals: term,
                    destinations: area
                }
            }))
            .then((data) => {
                let operation_types = [];
                let operation_types_data = data.operation_types.data;
                Object.keys(operation_types_data).forEach(key => {
                    operation_types.push({
                        id: key, value: operation_types_data[key]
                    });
                });

                this.setState({
                    operation_types,
                    terminals: data.terminals.data,
                    destination_areas: data.destinations.data,
                    products: data.products.data.filter(p => p.trip_type === 'INTERN')
                });
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if(prop === 'carrier_doc'){
            value = value.replace(/-/g, '');
        }

        let numbers = ['line_number', 'order_volume', 'provider_load_volume'];
        if(numbers.indexOf(prop) > -1){
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['operation_types', 'products', 'terminals', 'destination_areas', 'ajaxInProgress', 'id'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {
            if (data[key] === '') {
                data[key] = null;
            }
        });

        data['next_status'] = this.props.trip.status.id;

        const SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.id}/`;
        axios.put(`${SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = () => {
        swal({
            title: 'Viaje actualizado',
            html: 'El viaje ingresado ha sido actualizado correctamente. Espere unos segundos mientras lo redirigimos',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido actualizar el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {

        // Waiting for options
        if(!(this.state.destination_areas && this.state.products && this.state.terminals && this.state.operation_types)){
            return (
                <div className={"main-dashboard"}>
                    <Header active={"new-trip"} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>

            );
        }

        return (
            <div>
                <div className={"trip-section"}>
                    <div className={"trip-section-title"}>1. Información del viaje</div>
                    <ProgrammingForm
                        state={this.state}
                        user={this.props.user}
                        handleInput={this._handleInput}
                        handleDate={this._handleDateChange}
                        handleSelect={this._handleSelectChange}
                    />
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <Link to={'/internal-trips'} className={`btn btn-shell-empty z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Cancelar
                        </Link>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/TripProgrammingForm.js